module.exports = __webpack_public_path__ + "img/data_analysis_bac3.4733db2c.png";